import React from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

export default function Spinner({ size = 48, color = "text-green-600" }) {
  return (
    <div className="flex justify-center items-center">
      <AiOutlineLoading3Quarters
        className={`animate-spin ${color}`}
        style={{ width: `${size}px`, height: `${size}px` }}
      />
    </div>
  );
}
